<template>
  <div class="completed-homework-list">
    <completedHomeworkListTopbar
      :homeworkTopbarData="homeworkTopbarData"
      @searchHomeworkByStudentName="searchHomeworkByStudentName"
    />
    <div class="completed-homework-list-main">
      <div
        class="homework-list-container"
        v-bitmap="getCompletedHomeworkListRequest"
      >
        <completedHomeworkItem
          v-for="(item, index) in completedHomeworkList"
          :key="index"
          class="homework-item"
          :style="{
            'animation-duration': `${index <= 10 ? (index + 1) * 0.3 : 0.3}s`,
          }"
          :completedHomeworkItemData="item"
          @click.native="showHomeworkDetail(item)"
        />
      </div>
      <pagination
        :pageSize="pageSize"
        :total="total"
        @currentPageNumChange="currentPageNumChange"
      />
    </div>
    <el-dialog
      width="70%"
      :visible.sync="isHomeworkDetailDialogShow"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :title="dialogTitle"
    >
      <completedHomeworkDetail @refresh="refresh" :currentCompletedHomeworkData="currentCompletedHomeworkData" v-if="isHomeworkDetailDialogShow"/>
    </el-dialog>
  </div>
</template>

<script>
import completedHomeworkListTopbar from "./components/completed-homework-list-topbar/completedHomeworkListTopbar.vue";
import completedHomeworkItem from "./components/completed-homework-item/completedHomeworkItem.vue";
import completedHomeworkDetail from "./components/completed-homework-detail/completedHomeworkDetail.vue";
export default {
  data() {
    return {
      dialogTitle: "",
      pageSize: 20,
      pageNum: 1,
      total: 0,
      isHomeworkDetailDialogShow: false,
      getCompletedHomeworkListRequest: "nullData",
      homeworkTopbarData: {
        checkCount: 0,
        classCount: 0,
        submitCount: 0,
        title: "",
      },
      completedHomeworkList: [],
      searchHomeworkStudentKeyWord: "",
      currentCompletedHomeworkData: null,
    };
  },
  components: {
    completedHomeworkListTopbar,
    completedHomeworkItem,
    completedHomeworkDetail,
  },
  created() {
    this.getCompletedHomeworkList();
  },
  methods: {
    showHomeworkDetail(currentHomework) {
      this.dialogTitle = currentHomework.studentName + "的作业";
      this.currentCompletedHomeworkData = currentHomework;
      this.isHomeworkDetailDialogShow = true;
    },
    getCompletedHomeworkList() {
      this.getCompletedHomeworkListRequest = "loading";
      this.post(this.$url.selectSubmitHomeworkList, {
        homeworkId: this.$route.query.homeworkId,
        studentName: this.searchHomeworkStudentKeyWord,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      })
        .then((res) => {
          // console.log(res);
          if (res.code != 200) {
            this.getCompletedHomeworkListRequest = "error";
            return this.$message.error("获取已提交作业列表失败");
          }
          this.completedHomeworkList = res.data.homeworkSubjectList;
          this.completedHomeworkList.length > 0
            ? (this.getCompletedHomeworkListRequest = "success")
            : (this.getCompletedHomeworkListRequest = "nullData");
          const { checkCount, classCount, submitCount, title } = res.data;
          this.homeworkTopbarData = {
            checkCount,
            classCount,
            submitCount,
            title,
          };
          this.total = res.data.submitCount;
        })
        .catch((err) => {
          this.getCompletedHomeworkListRequest = "error";
          this.$message.error("获取已提交作业列表失败");
        });
    },
    currentPageNumChange(e) {
      this.pageNum = e;
      this.getCompletedHomeworkList();
    },
    searchHomeworkByStudentName(keyWord) {
      this.searchHomeworkStudentKeyWord = keyWord;
      this.getCompletedHomeworkList();
    },
    // 刷新
    refresh() {
      this.completedHomeworkList = [];
      this.getCompletedHomeworkList();
    },
  },
};
</script>

<style scoped lang="scss">
@import "./completedHomeworkList.scss";
</style>